import partnerService from '../service/partner'

const state = {
    partnerUsers: [],
    loading: false
}

const actions = {
    getPartnerUsers({ commit }) {
        commit('setLoading', true)
        return partnerService.getPartnerUsers().then(partnerUsers => {
            commit('setPartnerUsers', partnerUsers)
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    createPartnerUser({ commit }, partnerUser) {
        return partnerService.createPartnerUser(partnerUser).then(_id => {
            partnerUser._id = _id
            commit('addPartnerUser', partnerUser);
        })
    },
    updatePartnerUser({ commit }, partnerUser) {
        return partnerService.updatePartnerUser(partnerUser).then(() => {
            commit('updatePartnerUser', partnerUser);
        })
    },

    deletePartnerUser({ commit }, partnerUserId) {
        return partnerService.deletePartnerUser(partnerUserId).then(() => {
            commit('deletePartnerUser', partnerUserId);
        })
    }
};
const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    updatePartnerUser(state, updatedPartnerUser) {
        var partnerUser = state.partnerUsers.find(x => x._id == updatedPartnerUser.id)
        if (partnerUser) {
            partnerUser.name = updatedPartnerUser.name;
            partnerUser.surname = updatedPartnerUser.surname;
            partnerUser.email = updatedPartnerUser.email;
            partnerUser.phone = updatedPartnerUser.phone;
        }
    },
    addPartnerUser(state, partnerUser) {
        state.partnerUsers.push(partnerUser)
    },
    deletePartnerUser(state, partnerUserId) {
        var index = state.partnerUsers.findIndex(x => x._id == partnerUserId)
        if (index != -1) {
            state.partnerUsers.splice(index, 1)
        }
    },
    setPartnerUsers(state, partnerUsers) {
        state.partnerUsers = partnerUsers
        state.loading = false
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
